/**
 * SSR-safe accessor for `localStorage`.
 *
 * Resolves to the real `Storage` object, or `undefined` when it is unavailable
 * (server-side rendering, private mode, or storage disabled). Callers should
 * optional-chain on this and fail open. Reading the reference has no
 * side effects, so importing this module is inert.
 */
const resolveLocalStorage = (): Storage | undefined => {
  try {
    if (typeof window === "undefined") {
      return undefined;
    }
    return window.localStorage;
  } catch {
    return undefined;
  }
};

export const safeLocalStorage = resolveLocalStorage();
